import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { Component, Inject } from '@angular/core';
import { I18nService } from 'i18n/i18n.service';


@Component({
  selector: 'deleteEventLogAlert',
  styleUrls: ['delete-confirmation.component.scss'],
  templateUrl: './delete-confirmation.component.html'
})
export class DeleteConfirmationComponent {
  constructor(public modalComponentRef: BzgModalRef, private _i18nService: I18nService,
    @Inject(BZG_MODAL_DATA) public data: { message: string, title: string, button?: string }) { }

  close() {
    this.modalComponentRef.close();
  }
  delete() {
    this.modalComponentRef.close('delete');
  }
  includesReset(title) {
    return title.toLowerCase().includes('reset') || this.deleteProperty(title);
  }

  deleteProperty(title) {
    return title.toLowerCase().includes(this._i18nService.instant('ENVIRONMENT.DELETE_PROPERTY').toLowerCase())
  }
}
